export function emptyStringToNull<T extends string>(value: T | null) {
  if (value === "") {
    return null;
  }
  return value as Exclude<T, ""> | null;
}
